import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../features/navigation/Navigation';
import ContactDetails from '../features/contact/components/ContactDetails';
import ContactForm from '../features/contact/components/ContactForm';
import Footer from '../features/navigation/Footer';
import '../features/contact/Contact.styles.css';
import './ContactPage.styles.css';

// * [PAGE] Dedicated Contact Route (/contact) with verified channels and DPDP compliance
export const ContactPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.title = 'Contact | Yash Haldiya';
  }, []);

  return (
    <div className="contact-page-layout">
      <Navigation />

      <main className="contact-page-container">
        <div className="contact-page-breadcrumb">
          <Link to="/" className="breadcrumb-back-btn">
            <i className="fas fa-arrow-left" /> Back to Portfolio
          </Link>
        </div>

        <div className="contact-page-header">
          <span className="contact-badge">Direct Communication</span>
          <h1 className="contact-page-title">Let&apos;s Connect</h1>
          <p className="contact-page-subtitle">
            Have a project in mind, an engineering opportunity, or a question? Reach out through direct channels or send a secure message.
          </p>
        </div>

        <div className="contact-page-grid">
          <ContactDetails />
          <ContactForm />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
